export default function MyHealthScoreIcon() {
  return (
    <svg
      width="47"
      height="54"
      viewBox="0 0 47 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.6507 22.8223C45.4752 14.9185 40.5642 7.65546 33.6695 3.62269C26.7747 -0.410083 18.0389 -1.12618 10.5791 1.72722C10.5791 1.72722 10.5917 1.7068 10.5791 1.70994C7.74462 3.18454 7.9722 3.63839 6.2489 5.87306C3.7283 9.14105 2.01128 13.0058 1.06958 17.0229C0.255017 20.5123 0.0666793 24.1179 0.0117472 27.7015C-0.0416155 31.1156 0.0384224 34.6223 1.30029 37.796C2.08504 39.7826 3.32023 41.565 4.68411 43.2139C10.43 50.1456 19.8014 54.9337 28.4603 52.4792C33.7966 50.9669 38.0577 47.0064 41.8669 42.972C43.4741 41.2697 45.0749 39.4795 45.9476 37.3029C46.7323 35.3164 46.872 33.1335 46.9442 30.9947C47.04 28.2685 47.0525 25.525 46.6507 22.8223Z"
        fill="#ECF4FC"
      />
      <path
        d="M23.25 9.79199C31.9413 9.79199 39 16.9482 39 25.792C39 34.6358 31.9413 41.792 23.25 41.792C14.5587 41.792 7.5 34.6358 7.5 25.792C7.5 16.9482 14.5587 9.79199 23.25 9.79199Z"
        fill="white"
        stroke="#A3B7E4"
      />
      <path
        d="M19.3132 15.8633C20.7657 15.3288 21.5099 13.718 20.9754 12.2656C20.4408 10.8131 18.8301 10.0689 17.3776 10.6035L18.3454 13.2334L19.3132 15.8633ZM11.9575 18.2644L9.62758 16.7072L9.62758 16.7072L11.9575 18.2644ZM6.95181 26.2024L7.06337 29.0025L12.6637 28.7794L12.5521 25.9793L9.75195 26.0908L6.95181 26.2024ZM18.3454 13.2334L17.3776 10.6035C14.214 11.7677 11.5008 13.9045 9.62758 16.7072L11.9575 18.2644L14.2873 19.8216C15.5021 18.0041 17.2616 16.6183 19.3132 15.8633L18.3454 13.2334ZM11.9575 18.2644L9.62758 16.7072C7.75439 19.5098 6.81762 22.834 6.95181 26.2024L9.75195 26.0908L12.5521 25.9793C12.4651 23.7949 13.0726 21.6391 14.2873 19.8216L11.9575 18.2644Z"
        fill="#A3B7E4"
      />
      <path
        d="M30.581 18.1436C31.6574 19.2558 33.4315 19.2848 34.5436 18.2084C35.6558 17.1321 35.6848 15.3579 34.6084 14.2458L32.5947 16.1947L30.581 18.1436ZM25.4097 12.3877L24.9281 15.1484L25.4097 12.3877ZM19.0391 10.1157L16.3619 10.9438L18.018 16.2982L20.6952 15.4702L19.8672 12.793L19.0391 10.1157ZM32.5947 16.1947L34.6084 14.2458C32.264 11.8235 29.2123 10.2065 25.8914 9.62707L25.4097 12.3877L24.9281 15.1484C27.0816 15.5241 29.0607 16.5728 30.581 18.1436L32.5947 16.1947ZM25.4097 12.3877L25.8914 9.62707C23.4947 9.20888 21.1923 9.44977 19.0391 10.1157L19.8672 12.793L20.6952 15.4702C22.1211 15.0292 23.5215 14.903 24.9281 15.1484L25.4097 12.3877Z"
        fill="#A3B7E4"
      />
      <path
        d="M12.4958 26.8354C12.3852 25.2917 11.044 24.1299 9.50026 24.2406C7.95652 24.3512 6.79478 25.6924 6.90544 27.2361L9.70063 27.0358L12.4958 26.8354ZM19.0004 41.5796L21.7216 42.2491L23.0606 36.8067L20.3394 36.1372L19.6699 38.8584L19.0004 41.5796ZM9.70063 27.0358L6.90544 27.2361C7.14646 30.5985 8.4469 33.798 10.62 36.3751L12.7624 34.5686L14.9047 32.762C13.4955 31.0908 12.6521 29.0159 12.4958 26.8354L9.70063 27.0358ZM12.7624 34.5686L10.62 36.3751C12.7931 38.9522 15.727 40.7742 19.0004 41.5796L19.6699 38.8584L20.3394 36.1372C18.2166 35.6149 16.314 34.4333 14.9047 32.762L12.7624 34.5686Z"
        fill="#A3B7E4"
      />
      <path
        d="M20.8465 36.2784C19.3416 35.9168 17.8286 36.8436 17.467 38.3485C17.1054 39.8534 18.0322 41.3664 19.5371 41.728L20.1918 39.0032L20.8465 36.2784ZM28.2979 38.364L29.3716 40.9526L29.3716 40.9526L28.2979 38.364ZM36.8677 34.5396L38.3291 32.1485L33.5469 29.2256L32.0855 31.6167L34.4766 33.0781L36.8677 34.5396ZM20.1918 39.0032L19.5371 41.728C22.8148 42.5156 26.2578 42.2441 29.3716 40.9526L28.2979 38.364L27.2242 35.7755C25.2049 36.6131 22.9721 36.7891 20.8465 36.2784L20.1918 39.0032ZM28.2979 38.364L29.3716 40.9526C32.4853 39.661 35.1097 37.4159 36.8677 34.5396L34.4766 33.0781L32.0855 31.6167C30.9454 33.482 29.2435 34.938 27.2242 35.7755L28.2979 38.364Z"
        fill="#A3B7E4"
      />
      <path
        d="M32.5493 30.9612C31.7852 32.3072 32.2569 34.0177 33.6029 34.7818C34.9488 35.5458 36.6593 35.0741 37.4234 33.7282L34.9863 32.3447L32.5493 30.9612ZM36.6162 24.3785L39.4008 24.0634L39.4008 24.0634L36.6162 24.3785ZM37.4376 18.0096L36.0586 15.5701L31.1794 18.3281L32.5585 20.7677L34.998 19.3887L37.4376 18.0096ZM34.9863 32.3447L37.4234 33.7282C39.0876 30.7966 39.7799 27.413 39.4008 24.0634L36.6162 24.3785L33.8316 24.6936C34.0774 26.8658 33.6285 29.0601 32.5493 30.9612L34.9863 32.3447ZM36.6162 24.3785L39.4008 24.0634C39.1585 21.9218 38.4861 19.8645 37.4376 18.0096L34.998 19.3887L32.5585 20.7677C33.2385 21.9707 33.6745 23.3048 33.8316 24.6936L36.6162 24.3785Z"
        fill="#A3B7E4"
      />
      <rect
        x="32.466"
        y="29.7004"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        fill="#4E7FFF"
      />
      <rect
        x="32.466"
        y="29.7004"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        stroke="#A3B7E4"
        strokeWidth="0.420354"
      />
      <path
        d="M30.5796 18.1479C31.6559 19.26 33.4301 19.289 34.5422 18.2127C35.6543 17.1363 35.6833 15.3622 34.607 14.25L32.5933 16.199L30.5796 18.1479ZM26.0012 9.68506L23.2185 9.35379L22.5559 14.9192L25.3386 15.2505L25.6699 12.4678L26.0012 9.68506ZM32.5933 16.199L34.607 14.25C32.3995 11.9693 29.7936 10.1365 26.0012 9.68506L25.6699 12.4678L25.3386 15.2505C27.4312 15.4996 28.9223 16.4355 30.5796 18.1479L32.5933 16.199Z"
        fill="#A3B7E4"
      />
      <rect
        x="7.09787"
        y="23.7238"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        fill="#4E7FFF"
      />
      <rect
        x="7.09787"
        y="23.7238"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        stroke="#A3B7E4"
        strokeWidth="0.420354"
      />
      <rect
        x="14.813"
        y="10.9719"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        fill="#4E7FFF"
      />
      <rect
        x="14.813"
        y="10.9719"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        stroke="#A3B7E4"
        strokeWidth="0.420354"
      />
      <rect
        x="30.6037"
        y="14.3205"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        fill="#4E7FFF"
      />
      <rect
        x="30.6037"
        y="14.3205"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        stroke="#A3B7E4"
        strokeWidth="0.420354"
      />
      <rect
        x="17.6155"
        y="36.4738"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        fill="#4E7FFF"
      />
      <rect
        x="17.6155"
        y="36.4738"
        width="5.18437"
        height="5.18437"
        rx="2.59218"
        stroke="#A3B7E4"
        strokeWidth="0.420354"
      />
      <path
        d="M22.7861 20.0105C22.9521 19.9859 23.1198 19.9723 23.2877 19.9697C23.5951 19.9697 23.637 20.6324 23.7181 21.3246C23.7751 21.8086 23.8277 22.6032 23.8304 23.0898C23.8381 24.3736 23.8458 25.6574 23.8535 26.9412C23.8565 26.9636 23.8548 26.9863 23.8485 27.0081C23.8422 27.0299 23.8315 27.0502 23.817 27.0678C23.7983 27.0809 23.777 27.09 23.7544 27.0946C23.7319 27.0993 23.7086 27.0993 23.686 27.0947C23.3768 27.0747 22.729 27.2682 22.7014 26.9646C22.4653 24.3476 22.7014 22.8357 22.3272 20.6281C22.3148 20.5579 22.317 20.486 22.3334 20.4165C22.3499 20.3471 22.3803 20.2816 22.423 20.2237C22.4657 20.1658 22.5198 20.1168 22.5821 20.0795C22.6444 20.0421 22.7138 20.0172 22.7861 20.0062V20.0105ZM28.1012 28.0107C28.068 28.4938 27.9363 28.9656 27.7136 29.3986C27.3634 30.0821 26.9321 30.7543 26.3458 31.2748C24.929 32.5308 22.6684 32.6991 20.9835 31.8109C19.4785 31.018 18.468 29.4836 18.1864 27.8381C18.1743 27.7615 18.1786 27.6833 18.1991 27.6085C18.2197 27.5336 18.256 27.4638 18.3058 27.4033C18.3556 27.3429 18.4177 27.2932 18.4883 27.2574C18.5588 27.2216 18.6363 27.2004 18.7157 27.1953C18.8886 27.1826 19.0614 27.171 19.2343 27.1606C19.3067 27.1563 19.3785 27.1748 19.4392 27.2134C19.4999 27.252 19.5461 27.3086 19.5711 27.3749C19.6927 27.6978 19.8418 28.0103 20.0166 28.3091C20.5736 29.2632 21.5484 30.0335 22.6693 30.1445C23.9426 30.2703 25.1981 29.5105 25.8664 28.4479C26.0072 28.2232 26.1765 27.9274 26.3432 27.6125C26.3822 27.5379 26.444 27.477 26.5201 27.438C26.5963 27.399 26.6829 27.3839 26.7682 27.3948C27.0688 27.433 27.3696 27.4752 27.6708 27.5215C27.8063 27.5423 27.956 27.5718 28.037 27.6793C28.0962 27.778 28.1189 27.8934 28.1012 28.0064V28.0107ZM28.1449 22.0064C27.8553 22.4662 27.3126 22.7949 26.762 22.7403C26.2772 22.6926 25.8557 22.3595 25.6143 21.9466C25.3728 21.5337 25.2525 20.6593 25.2525 20.6593C25.2525 20.5925 25.3915 20.5518 25.5938 20.5231C25.6157 20.5202 25.638 20.5243 25.6572 20.5347C25.6765 20.5452 25.6918 20.5616 25.7007 20.5813C25.731 20.6446 25.764 20.7079 25.8014 20.7721C26.0046 21.1191 26.3601 21.401 26.7691 21.4409C27.2324 21.4868 27.6904 21.2101 27.9337 20.8224C27.98 20.7487 28.0353 20.655 28.0896 20.5518C28.1073 20.5186 28.1341 20.4909 28.1669 20.4716C28.1998 20.4523 28.2375 20.4422 28.2759 20.4425H28.4345C28.9887 20.4459 28.4336 21.5424 28.1449 22.0021V22.0064Z"
        fill="#4E7FFF"
      />
    </svg>
  );
}
